export default __webpack_public_path__ + "static/FAM16061005-ddfca094fcb4651809c793e04eea4910.jpg";